import { ArrowDownS16 } from '@cian/ui-kit/prev';
import * as React from 'react';
import * as styles from './ShowMoreLink.css';

interface IDocumentationShowMoreButtonProps {
  children: React.ReactNode;
  onClick: () => void;
}

export function ShowMoreLink({ children, onClick }: IDocumentationShowMoreButtonProps) {
  return (
    <button onClick={onClick} className={styles['show']} data-testid="ShowMoreButton">
      {children}
      <div className={styles['show__icon']}>
        <ArrowDownS16 color="primary_100" />
      </div>
    </button>
  );
}
